import moment from "moment";
import { FormatNumber2 } from "../../utility/functions/formatNumber";

export const SaleSummaryColumns = (width) => {
  const columns = [
    {
      field: "ICODE",
      accessor: "ICODE",

      type: "string",
      headerAlign: "center",
      width: 80,
      headerClassName: "super-app-theme--header",

      renderCell: (param) => {
        return (
          <div
            style={{
              color: "black",
            }}
            className={`h-full w-full  flex items-center   `}
          >
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => <div className="text-white"> {"Code"} </div>,
    },


    {
      field: "BRAND_NAME",
      accessor: "BRAND_NAME",
      type: "string",
      headerAlign: "center",

      width: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={` h-full w-full flex items-center  `}
          >
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white"> {"Brand Name"} </div>
      ),
    },
    {
      field: "DEP_NAME",
      accessor: "DEP_NAME",
      type: "string",
      headerAlign: "center",

      width: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={` h-full w-full flex items-center  `}
          >
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white"> {"Department "} </div>
      ),
    },
    {
      field: "SECTION_NAME",
      accessor: "SECTION_NAME",
      type: "string",
      headerAlign: "center",

      width: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={` h-full w-full flex items-center  `}
          >
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white"> {"Section"} </div>
      ),
    },
    {
      field: "ITEMNAME",
      accessor: "ITEMNAME",
      type: "string",
      headerAlign: "center",

      width: 220,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={` h-full w-full flex items-center  `}
          >
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white"> {"Item Name"} </div>
      ),
    },
    {
      field: "MARGIN",
      accessor: "MARGIN",
      type: "string",
      headerAlign: "center",

      width: 160,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={` h-full w-full justify-end flex items-center  `}
          >
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white"> {"Margin (by MRP)"} </div>
      ),
    },
    {
      field: "MARGIN2",
      accessor: "MARGIN2",
      type: "string",
      headerAlign: "center",

      width: 160,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
       console.log(params)
        return (
          <div
            style={{
              color:  "black",
            }}
            className={` h-full w-full justify-end flex items-center  `}
          >
            {FormatNumber2(params.row.original.SALE_PRICE - params.row.original.PUR_PRICE) }
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white"> {"Margin (by sale price)"} </div>
      ),
    },
    {
      field: "MRP_RATE",
      accessor: "MRP_RATE",
      type: "string",
      width:80,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={`h-full w-full justify-end  flex items-center   `}
          >
            {FormatNumber2( param.value)}
          </div>
        );
      },
      renderHeader: (params) => <div className="text-white"> Mrp Rate</div>,
    },

    {
      field: "NET_PURCHASE_PRICE",
      accessor: "NET_PURCHASE_PRICE",
      type: "number",
      renderCell: (param) => {
        return (
          <div
            style={{
              color: "black",
            }}
            className={`h-full w-full justify-end  flex items-center   `}
          >
            {param.value}
          </div>
        );
      },

      headerClassName: "super-app-theme--header",
      width:130,
      headerAlign: "center",
      align: "left",

      renderHeader: (params) => (
        <div className="text-white  whitespace-normal"> Net Pur. Price</div>
      ),
    },

    {
      field: "PUR_PRICE",
      accessor: "PUR_PRICE",
      type: "number",
      width: 150,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={`h-full w-full  justify-end flex items-center   `}
          >
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white"> Pur. Price</div>
      ),
    },

    {
      field: "SALE_PRICE",
      accessor: "SALE_PRICE",
      type: "string",
      width: 90,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div
            style={{
              color:  "black",
            }}
            className={`h-full w-full justify-end  flex items-center   `}
          >
            {FormatNumber2(param.value) }
          </div>
        );
      },
      renderHeader: (params) => <div className="text-white">Sale Price</div>,
    },



 
  ];

  return columns;
};
